module.exports = __webpack_public_path__ + "img/carlos.ad2e7b78.png";